import routes from './routes';

export default routes;
export * from './Components/index';
export * from './Pages/index';
